// Add theme drawers for custom Nomad Experience menu
theme.NavDrawerExperience = new theme.Drawers('NavDrawerExperience', 'nav-experience');
theme.collapsibles.init(document.getElementById('NavDrawerExperience'));

/*  ===================================
 *  FREE SHIPPING TRESHOLD WIDGET
 *  - Simple widget that adds a progress bar indicating how far they are for free shipping
 *  ===================================
 */

(function(w,d){
    const settings = {
        container: 'FSTContainer',
        progress_bar: 'FSTBar',
        message: 'FSTMessage',
        message_error: 'Please enter a target goal amount in the Theme Settings > Cart > Free Shipping Threshold'
    }
    const container = d.getElementById(settings.container);
    let data;
    let exchange_rate = Shopify.currency.rate;

    function initData() {
        const dataset = container.dataset.settings ?? new Object;
        if (Object.keys(dataset).length === 0) return;
        data = JSON.parse(dataset);
    }

    function fetchCartData() {
        fetch((window.theme.routes.cart ? window.theme.routes.cart : '/cart.js'), {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => calculateShipping(data));
    }

    function renderElements() {
        // Set data
        let currency_modifier = 1;
        let symbol = "$"
        let convert = false;
        if (data.shop_currency != data.cart_currency) {
            currency_modifier = exchange_rate;
            symbol = `${window.theme.settings.cartCurrencySymbol}`;
            convert = true;
        }
        const mod_target = data.target ? parseFloat(data.target) * currency_modifier : null;
        const mod_step_target = data.step_target ? parseFloat(data.step_target) * currency_modifier : null;

        const labelHTML = d.createElement('label')
        labelHTML.setAttribute('for', settings.progress_bar)
        // labelHTML.textContent = 'Free shipping progress'

        const progressBarHTML = d.createElement('progress')
        progressBarHTML.id = settings.progress_bar
        progressBarHTML.setAttribute('max', 100)
        progressBarHTML.setAttribute('value', 0)
        progressBarHTML.dataset.target = data.target ?? null

        const progressBarWrapper = d.createElement('div')
        progressBarWrapper.classList.add('fst-progress-bar-wrapper')
        progressBarWrapper.dataset.symbol = symbol
        if (convert) {
            if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                progressBarWrapper.dataset.target = mod_target.toFixed(0) ?? null
            } else {
                progressBarWrapper.dataset.target = mod_target.toFixed(2) ?? null
            }
        } else {
            progressBarWrapper.dataset.target = data.target ?? null
        }
        progressBarWrapper.appendChild(progressBarHTML)

        const messageHTML = d.createElement('div')
        messageHTML.id = settings.message
        messageHTML.classList.add('fst-message')

        container.appendChild(messageHTML);
        container.appendChild(labelHTML);

        // Step Label
        if (data.step_target && data.step_target != '') {
            const stepLabel = d.createElement('span');
            stepLabel.classList.add("fst-step-target");
            stepLabel.setAttribute('data-pos', `${(parseInt(data.step_target) / parseInt(data.target)) * 100}`);
            stepLabel.style.left = `${(parseInt(data.step_target) / parseInt(data.target)) * 100}%`;
            if (convert) {
                if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                    stepLabel.innerHTML = `${symbol}${mod_step_target.toFixed(0)}`;
                } else {
                    stepLabel.innerHTML = `${symbol}${mod_step_target.toFixed(2)}`;
                }
            } else {
                stepLabel.innerHTML = `$${data.step_target}`;
            }

            progressBarWrapper.appendChild(stepLabel);
        }
        
        container.appendChild(progressBarWrapper);
    }

    function calculateShipping(cartJson) {
        let currency_modifier = 1;
        let symbol = "$"
        let convert = false;
        if (data.shop_currency != data.cart_currency) {
            currency_modifier = exchange_rate;
            symbol = `${window.theme.settings.cartCurrencySymbol}`;
            convert = true;
            // cart_total = cart_total / exchange_rate;
        }

        const target = data.target ? parseFloat(data.target) : null;
        const mod_target = data.target ? parseFloat(data.target) * currency_modifier : null;
        let cart_total = (cartJson.total_price ? cartJson.total_price : cartJson.final_price) / 100;
        let mod_cart_total = cart_total / currency_modifier;
        
        let progress_value = (cart_total / target) * 100;
        progress_value = (mod_cart_total / target) * 100;

        const remaining = target - cart_total;
        const mod_remaining = mod_target - cart_total;
        let message = '';

        if (target) {
            // Set value of progress bar
            if (progress_value >= 100){
                d.getElementById(settings.progress_bar).setAttribute('value', 100);
                d.getElementById(settings.progress_bar).parentElement.setAttribute('value', 100);
                d.getElementById(settings.progress_bar).style.setProperty('--percentage', "calc(100% - 14px)");
            }
            else {
                d.getElementById(settings.progress_bar).setAttribute('value', progress_value ? progress_value : 0);
                d.getElementById(settings.progress_bar).parentElement.setAttribute('value', progress_value ? progress_value : 0);
                d.getElementById(settings.progress_bar).style.setProperty('--percentage', `calc(${progress_value ? progress_value : 0}% - 14px)`);
            }

            const stepTarget = data.step_target ? parseFloat(data.step_target) : null;
            const mod_step_target = data.step_target ? parseFloat(data.step_target) * currency_modifier : null;
            const stepMessage = data.message_step_ongoing;

            // message = data.message_default.replace('[target]', `$${target}`);
            if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                message = data.message_default.replace('[target]', `${symbol}${mod_target.toFixed(0)}`);
            } else {
                message = data.message_default.replace('[target]', `${symbol}${mod_target.toFixed(2)}`);
            }
            if (mod_remaining <= 0) {
                message = data.message_success;
            }
            if (mod_remaining > 0 && mod_remaining < mod_target) {
                // message = data.message_ongoing.replace('[remaining]', `$${remaining ? remaining.toFixed(2) : target}`);
                if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                    message = data.message_ongoing.replace('[remaining]', `${symbol}${remaining ? mod_remaining.toFixed(0) : mod_target}`);
                } else {
                    message = data.message_ongoing.replace('[remaining]', `${symbol}${remaining ? mod_remaining.toFixed(2) : mod_target}`);
                }
            }

            if (stepTarget) {
                const mod_step_target = stepTarget * currency_modifier;
                const stepRemaining = stepTarget - cart_total;
                const mod_step_remaining = mod_step_target - cart_total;

                if (mod_step_remaining > 0) {
                    // message = stepMessage.replace('[remaining]', `$${stepRemaining ? stepRemaining.toFixed(2) : stepTarget}`);
                    if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                        message = stepMessage.replace('[remaining]', `${symbol}${stepRemaining ? mod_step_remaining.toFixed(0) : mod_step_target}`);
                    } else {
                        message = stepMessage.replace('[remaining]', `${symbol}${stepRemaining ? mod_step_remaining.toFixed(2) : mod_step_target}`);
                    }
                }
            }
        }
        else
            message = settings.message_error

        // Display message
        d.getElementById(settings.message).innerHTML = message;

        // Hide free shipping widget when cart has a product type of "Rods" or "Rods - Seacore"
        let rodsChecker = cartJson.items.find(x => x.product_type === 'Rods' || x.product_type === 'Rods - Seacore' );
       
        if ( rodsChecker ) {
            document.querySelector('#CartDrawer .drawer__fixed-header').classList.add('has-rods');
        } else {
            document.querySelector('#CartDrawer .drawer__fixed-header').classList.remove('has-rods');
        }
    }

    function init() {
        if (!container) return;

        initData();
        renderElements();
        fetchCartData();

        // Listeners for product added and cart updates
        ['cart:ready', 'ajaxProduct:added'].forEach(evt =>
            d.addEventListener(evt, fetchCartData, false)
        );
    }

    init();
})(window, document)


// Add theme disclosure for currency selector in drawer menu
let drawerCurrencySelector = document.querySelector('.currency-selector .disclosure');
if(drawerCurrencySelector) {
    new theme.Disclosure(drawerCurrencySelector);
}

// Graph QL for blogs
theme.GraphQL = {

    config:  {
        storefront_token: '76239be0aba15871a058c126a838c3b7',
        request_url: theme.routes.storefrontAPI
    },

    sendRequest: function(request, request_group, output_container, tag, show_tags, show_date, show_excerpt) {

        if(this.config[request_group] == null) {
            this.config[request_group] = 1;
        } else {
            this.config[request_group]++;
        }

        let return_response = null;

        let settings = {
            'crossDomain': true,
            'url': this.config.request_url,
            'method': 'POST',
            'headers': {
                'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                'Content-Type': 'application/graphql',
            },
            'data': request,
            'success': function(response) {
                theme.GraphQL.config[request_group]--;
                return_response = response;
            },
            'error': function(xhr, errDesc) {
                theme.GraphQL.config[request_group]--;
                console.log(errDesc);
            }
        };
        $.ajax(settings)
            .done(function() {
                if(request_group === "featured_blogs") {
                    theme.featured_blogs.build_output(return_response, output_container, tag, show_tags, show_date, show_excerpt);
                }
                theme.GraphQL.cleanUp(request_group);
            });
    },

    cleanUp: function(request_group) {
        if(theme.GraphQL.config[request_group] < 1) {
            $('body').trigger(request_group+":loaded");
            delete this.config[request_group];
        }
    }
};

theme.featured_blogs = (function() {

    function init(container){
        let $output_container = $(container);
        let blog_handle = $(container).data("blog-handle");
        let tag = $(container).data("tag");
        let show_tags = $(container).data("tags");
        let show_date = $(container).data("date");
        let show_excerpt = $(container).data("excerpt");
        let request_query = `
        {
            blogByHandle(handle: "${blog_handle}") {
            handle
              articles(first: 3, query: "tag:${tag}") {
                edges {
                  node {
                    excerpt
                    content
                    video_url_feature: metafield(
                        key: "video_url_feature", 
                        namespace: "custom_fields"
                    ) {
                        value
                    }
                    image {
                      url
                      altText
                    }
                    publishedAt
                    title
                    handle
                  }
                }
              }
            }
          }
        `;
        theme.GraphQL.sendRequest(request_query, "featured_blogs", $output_container, tag, show_tags, show_date, show_excerpt);
    }

    function build_output(return_response, output_container, tag, show_tags, show_date, show_excerpt) {
        let articles = return_response.data.blogByHandle.articles.edges;
        let blog_handle = return_response.data.blogByHandle.handle;
        let slider = false;
        let sliderContainer;
        if(output_container[0].dataset.slider === 'featured-blogs-ql') {
            slider = true;
            sliderContainer = document.querySelector(`.article-container[data-slider="featured-blogs-ql"][data-blog-handle="${blog_handle}"][data-tag="${tag}"]`);
        }
        for(let i=0; i < articles.length; i++) {
            let date_options =  { year: 'numeric', month: 'long', day: 'numeric' };
            let date = new Date(articles[i].node.publishedAt);
            let formatted_date = date.toLocaleDateString("en-US", date_options);
            let url = '';
            let html = `
                <div class="grid__item medium-up--one-third aos-init aos-animate" data-aos="row-of-3">
                    <div class="grid article-wrapper">
                        <div class="grid__item article-image-wrapper">`;
            if(articles[i].node.video_url_feature != null) {
                url = articles[i].node.video_url_feature;
            } else {
                url = `/blogs/${blog_handle}/${articles[i].node.handle}`;
            }
            html += `<a href="${url}" class="article__grid-image" aria-label="${articles[i].node.title}">
                        <div class="image-wrap">
                            <div class="grid__image-ratio grid__image-ratio--wide">
                                <img class="lazyload" src="${articles[i].node.image.url}" alt="${articles[i].node.image.altText}">
                            </div>`;
            if(articles[i].node.video_url_feature != null) {
                html += `<div class="video-button-wrapper"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-play" viewBox="18.24 17.35 24.52 28.3"><path fill="#323232" d="M22.1 19.151v25.5l20.4-13.489-20.4-12.011z"/></svg> Play Video</div>`;
            }
            html += `</div>
                    </a>
                    </div>
                        <div class="grid__item article-content-wrapper">
                        <div class="article__grid-meta">`;
                            if(show_tags || show_date) {
                                html += '<div class="article__date">';
                                if(show_tags) {
                                    html += `${tag}`;
                                }
                                if(show_tags && show_date) {
                                    html += '<span class="divider">|</span>';
                                }
                                if(show_date) {
                                    html += `${formatted_date}`;
                                }
                                html += '</div>';
                            }
                            html += `<a href="/blogs/${blog_handle}/${articles[i].node.handle}" class="article__title">${articles[i].node.title}</a>`;
                            if(show_excerpt) {
                                html += '<div class="rte article__excerpt">';
                                if(articles[i].node.excerpt != '') {
                                    html += `${articles[i].node.excerpt.substring(0,100)}...`;
                                } else {
                                    html += `${articles[i].node.content.substring(0,100)}...`;
                                }
                                html += '</div>';
                            }
                            html += `<a href="/blogs/${blog_handle}/${articles[i].node.handle}" class="read-more-link">Read More</a>
                        </div>
                        </div>
                    </div>
                </div>
            </div>`;                           
            output_container.append(html);
        }
        if(slider) {
            initBlogSlider(sliderContainer, 1);
        }
    }

    return {
        init: init,
        build_output: build_output
    }
})();

// $(document).ready(function() {
//     $('[data-section-type="featured_blogs"]').each(function() {
//         theme.featured_blogs.init(this);
//     });
// });

const featuredBlogs = document.querySelectorAll('[data-section-type="featured_blogs"]');
featuredBlogs.forEach(blog => {
  theme.featured_blogs.init(blog);
})

// GRAPHQL FOR PLP VARIANTS
const getVariantMetafields = async (data) => {

    const config = {
        storefront_token: '13bdd6e6092ea123faf669bfb3790350',
        request_url: theme.routes.storefrontAPI_2
    }

    let request_query = `
        {
            productByHandle(handle: "${data}") {
                availableForSale
                id
                title
                variants(first: 100) {
                    edges {
                        node {
                            availableForSale
                            metafields(identifiers: [{key: "pre_order_quantity_limit", namespace: "custom"}, {key: "customer_pre_order_limit", namespace: "custom"}]) {
                                value
                            }
                            quantityAvailable
                            id
                        }
                    }
                }
            }
        }
    `;

    let return_response = null;

    let settings = {
        'crossDomain': true,
        'url': config.request_url,
        'method': 'POST',
        'headers': {
            'X-Shopify-Storefront-Access-Token': config.storefront_token,
            'Content-Type': 'application/graphql',
        },
        'data': request_query,
        'success': function(response) {
            return_response = response;
        },
        'error': function(xhr, errDesc) {
            console.log(errDesc);
        }
    };

    const result = await $.ajax(settings)
        .done(function() {
            return return_response;
        });

    return result;
};

// Custom modals using theme.js Modals
const modals = document.querySelectorAll('.js-modal-trigger');
if(modals) {
    modals.forEach(modal => {
        let m = new theme.Modals(modal.dataset.contentId);

        modal.addEventListener('click', e => {
            m.open();
        });
    });
}

// Wait for a particular element to display
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

window.addEventListener('DOMContentLoaded', () => {
    // Slider   
    let grids = document.querySelectorAll('.blog-slider[data-slider="featured-blogs"]');
    if(grids) {
        grids.forEach(function(item, index) {
            initBlogSlider(item, index);
        });
    }   
});
var flkty = [];
function initBlogSlider(item, index) {
    let args = {
        cellAlign: 'center',
        contain: true,
        imagesLoaded: true,
        pageDots: true,
        prevNextButtons: false,
        dragThreshold: 10,
        selectedAttraction: 0.1,
        friction: 0.4,
        wrapAround: true
    };
    flkty[index] = new theme.Slideshow(item, args);
    return flkty;
}

window.addEventListener('DOMContentLoaded', () => {
    if (window.location.hash.length) {
        if (window.location.hash.includes('newsletter-footer')) {
            // setting timeout to ensure all is loaded
            setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight);
            }, 750)
        }
    }
});

const mobileBtnSearch = document.querySelector(".btn__search");
const mobileBtnSearchFormClose = document.querySelector(".btn__close-search__form");
const mobileSearchForm = document.querySelector(".item__search");

mobileBtnSearch.addEventListener("click", function () {
    mobileSearchForm.classList.remove('small--hide');
    document.querySelector('.toolbar').classList.remove('small--hide');
});

mobileBtnSearchFormClose.addEventListener("click", function () {
    mobileSearchForm.classList.add('small--hide');
    document.querySelector('.toolbar').classList.add('small--hide');
});

window.addEventListener("load",function(event) {
    jQuery(document).on('change', '.grid-product__variants-wrapper select', async function () {
        var thisElement = jQuery(this);
        var price = thisElement.find(":selected").attr("data-price");
        var preorderquantitylimit = thisElement.find(":selected").attr("data-preorderquantitylimit");
        var inventorypolicy = thisElement.find(":selected").attr("data-inventorypolicy");
        var selectedVProductHandle = thisElement.find(":selected").attr("data-producthandle");
        var selectedVariant = thisElement.find(":selected").val();
        var propertiesPreOrderLimit = thisElement.parents('.grid-product__content').find('.propertiesPreOrderLimit');

        price_html = `${price}`;

        thisElement.parents('.grid-product__content').find('.grid-product__price').html(price_html);
        propertiesPreOrderLimit.val(preorderquantitylimit);
        if ( !preorderquantitylimit ) {
            // E.g.: Boost PF&S result
            const variantData = await getVariantMetafields(selectedVProductHandle);
        
            if (!variantData.data.productByHandle) {
                return; // accounts for cart upsell
            }

            // get selected variant data
            const selectedVariantData = variantData.data.productByHandle.variants.edges.find(edge => {
                return edge.node.id.includes(selectedVariant)
            })

            const meta_pre_order_qty_limit = +selectedVariantData.node.metafields?.[0]?.value;
            const meta_customer_pre_order_limit = +selectedVariantData.node.metafields?.[1]?.value;

            // update pre order limit
            if (meta_pre_order_qty_limit) {
                preorderquantitylimit = selectedVariantData.node.quantityAvailable + meta_pre_order_qty_limit;
            }
            // check for customer pre order limit
            let max_message = false;
            if (meta_customer_pre_order_limit) {
                if (meta_customer_pre_order_limit > preorderquantitylimit) {
                    max_message = `(Max: ${preorderquantitylimit})`;
                } else {
                    max_message = `(Max: ${meta_customer_pre_order_limit})`;
                }
            }

            if (meta_customer_pre_order_limit && preorderquantitylimit > meta_customer_pre_order_limit) {
                preorderquantitylimit = meta_customer_pre_order_limit;
            }

            if ( preorderquantitylimit || preorderquantitylimit == 0 ) { // 0 evaluates to FALSE
                if ( preorderquantitylimit > 0 && inventorypolicy == 'continue' ) {
                    thisElement.parents('.grid-product__content').find('button.grid-product__atc').html(`Pre Order${max_message ? '<br>' + max_message : ''}`);
                    thisElement.parents('.grid-product__content').find('button.grid-product__atc').prop( "disabled", false );

                } else {
                    thisElement.parents('.grid-product__content').find('button.grid-product__atc').html('Add to Cart');

                    if (preorderquantitylimit <= 0) {
                        thisElement.parents('.grid-product__content').find('button.grid-product__atc').html('Sold Out');
                        thisElement.parents('.grid-product__content').find('button.grid-product__atc').prop( "disabled", true );
                    }
                }
            } else {
                thisElement.parents('.grid-product__content').find('button.grid-product__atc').html('Add to Cart');
            }        
        } else {
            if ( preorderquantitylimit > 0 && inventorypolicy == 'continue' ) {
                thisElement.parents('.grid-product__content').find('button.grid-product__atc').html(`Pre Order<br/>(Max: ${preorderquantitylimit})`);
                thisElement.parents('.grid-product__content').find('button.grid-product__atc').prop( "disabled", false );
            } else {
                thisElement.parents('.grid-product__content').find('button.grid-product__atc').html('Add to Cart');
                if (preorderquantitylimit <= 0) {
                    thisElement.parents('.grid-product__content').find('button.grid-product__atc').html('Sold Out');
                    thisElement.parents('.grid-product__content').find('button.grid-product__atc').prop( "disabled", true );
                }
            }
        }
    });
});